<ng-container *transloco="let t;">
    <div class="d-flex justify-content-between align-items-start">
        <div class=" px-2 pt-50 pb-0 cc-custom-filters">
    
            <div class="d-flex justify-content-start columngap align-items-center">
                <form [formGroup]="defaultFilterForm" class="d-flex align-items-center">
                    <div class="d-flex pe-1">
                        <div class="form-group mb-0 d-flex justify-content-start align-items-center">
                            <label class="font-small-3 font-weight-500 mb-0 me-25" for="customSelect">{{ t('Default filter status field label - (Contract control listing section) - Status') }}</label>
                            <ng-select [items]="contractStatuaFilter" [readonly]="readonly" bindValue="value"
                                       (change)="onStatusSelect()"
                                bindLabel="name" formControlName="status" [searchable]="false" [placeholder]="t('Default filter dropdown placeholder - (Contract control listing section) - All')">
                            </ng-select>
                        </div>
                    </div>
                    <div class="d-flex pe-1 p-0">
                        <div class="form-group mb-0 d-flex justify-content-start align-items-center">
                            <label class="font-small-3 font-weight-500 mb-0 me-25" for="customSelect">{{ t('Default filter type field label - (Contract control listing section) - Type') }}</label>
                            <ng-select #SelectDocTypeSR [items]="(documentTypes$ | async) | documentTypeSelectorFor: 'contract'" formControlName="document_type"
                                bindValue="id" bindLabel="document_type" [readonly]="readonly" [searchable]="false"
                                [placeholder]="t('Default filter dropdown placeholder - (Contract control listing section) - All')"
                                (change)="applyDocumentTypeLayoutSettings($event)">
                                <ng-template ng-header-tmp>
                                    <input class="form-control w-100" type="text"
                                        (input)="SelectDocTypeSR.filter($event.target.value)" />
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="d-flex">
                        <!-- <div class="form-group mb-0 d-flex justify-content-start align-items-center">
                            <label class="font-small-3 font-weight-500 mb-0 me-25" for="customSelect">{{ t('Default filter category field label - (Contract control listing section) - Category') }}</label>
                            <ng-select formControlName="category_id" [items]="categories | documentTypeAllowedCategories: selectedDocumentType: 'allowNull'" bindLabel="category_name"
                                bindValue="id" [readonly]="readonly" [searchable]="true" [placeholder]="t('Default filter dropdown placeholder - (Contract control listing section) - All')"
                                (change)="onCategorySelect()"
                            >
                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                    <span [ngClass]="{'sub-menu': item?.is_sub && item?.is_sub === 1}">
                                        {{ item.category_name }}
                                    </span>
                                </ng-template>
                            </ng-select>
                        </div> -->
                        <div class="form-group mb-0 d-flex justify-content-start align-items-center">
                            <app-global-category-dropdown
                                [categories]="categories"
                                [selectedCategoryId]="selectedCategoryId"
                                [label]="t('Category Filter label (Document and CC filters) - Category')"
                                (categorySelected)="onCategorySelectChange($event)"
                            ></app-global-category-dropdown>
                        </div>
                    </div>
                </form>
                @if (showAdvancedFilters){
                    <div class="bordered-spacer"></div>
                    <div class="form-group mb-0 d-flex justify-content-start d-flex align-items-center">
                        <div ngbDropdown container="body" class="d-flex">
                            <button type="button" class="btn btn-sm m-0 p-0 hide-arrow d-flex" container="body"
                                    placement="auto" [autoClose]="true" triggers="hover" ngbTooltip=""
                                    ngbDropdownToggle
                                    data-toggle="dropdown">
                                <label placement="auto" [autoClose]="true" triggers="hover"
                                    class="font-small-3 cursor-pointer mb-0 me-25 font-weight-500 addvanceFiltertexthover">{{ t('Button name (documents advanced filters) - Advanced filter') }}</label>
                            </button>
                            <div ngbDropdownMenu class="documentAdvanceFilterDropdown">
                                <app-advanced-filters-list [items]="advancedFiltersList$ | async"
                                                        [loading]="isAdvancedFiltersListLoading$ | async"
                                                        (searchChanged)="advancedFilterSearch($event)"
                                                        (addNewFilter)="addNewFilter($event)"
                                ></app-advanced-filters-list>
                            </div>
                        </div>
                    </div>
    
                <div *ngIf="(savedFiltersList$ | async)?.length > 0" class="bordered-spacer"></div>
                
                <div *ngIf="(savedFiltersList$ | async)?.length > 0" class="d-flex justify-content-start align-items-center">
                    <div  class="form-group mb-0 d-flex justify-content-start align-items-center">
                        <label class="font-small-3 font-weight-500 mb-0 me-25">{{ t('Custom filters dropdown label - (Contract control listing section) - Custom filters') }}</label>
                        <ng-select #SelectFilter [ngModel]='selectedSavedFilterId$ | async'
                            [items]="savedFiltersList$ | async" [readonly]="readonly" [searchable]="false"
                            (ngModelChange)="onSelectedSavedFilterChange($event)" bindValue="id" bindLabel="name"
                            [placeholder]="t('Custom filters dropdown placeholder - (Contract control listing section) - Select')"
                            class="font-small-3 manageFilterSelect"
                        >
                            <ng-template ng-footer-tmp>
                                <span class="cursor-pointer font-small-3 d-flex align-items-center manageFilterIconHover"  (click)="manageSavedFilters(); SelectFilter.close()"><i data-feather="settings" [size]="12" class=" me-50"></i>{{ t('Manage filters modal title (Manage filters modal) - Manage filters') }} </span>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                
                <span *ngIf="(selectedSavedFilterId$ | async) !== null" placement="auto" class="d-flex" container="body"
                    [autoClose]="true" triggers="hover" [ngbTooltip]="t('Delete (general) - Delete')" (click)="onSelectedSavedFilterChange(null)">
                    <i data-feather="x-circle" [size]="12" class="text-danger cursor-pointer"></i>
                </span>
                
                <div *ngIf="hasAnyFiltersApplied$ | async" class="bordered-spacer"></div>
                <div class="d-flex align-items-center cursor-pointer"  *ngIf="hasAnyFiltersApplied$ | async">
                    <button class="font-small-3 cursor-pointer btn-sm mb-0 me-25 font-weight-500 addvanceFiltertexthover  btn btn-success" [disabled]="(allFiltersValid$ | async) === false" (click)="onSaveFilterClicked()">{{ t('Save filters modal title (save filters modal) - Save filter') }}</button>
                </div>
                }
            </div>
            @if (showAdvancedFilters){
            <div class="d-flex add-more-filters p-0">
                <app-applied-advanced-filter
                    [items]="advancedFiltersList$ | async"
                    [loading]="isAdvancedFiltersListLoading$ | async"
                    [filtersList]="appliedAdvancedFilters$ | async"
                    (addNewFilter)="addNewFilter($event)"
                    (removeFilter)="onRemoveFilter($event)"
    
                    (search)="advancedFilterSearch($event)"
                ></app-applied-advanced-filter>
            </div>
            }
        </div>
        <div class="btn-group perPageRecords m-50">
            <div ngbDropdown>
                <button ngbDropdownToggle class="btn btn-flat-secondary" type="button" id="dropdownMenuButton100"
                    rippleEffect>
                    {{perPageRecords}} 
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownMenuButton100">
                  <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(20)">20</a>
                  <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(50)">50</a>
                  <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(100)">100</a>
                  <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(500)">500</a>
                  <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(1000)">1000</a>
                </div>
            </div>
        </div>
    </div>
</ng-container>
